import { OperActions, OperPostActions } from '..'
import { HttpServiceResponse } from '../../shared'
import { ApplicationOperParams } from '../models/oper/oper-params.model'
import { ApplicationOperPostParams } from '../models/oper/oper_post-params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class OperProvider extends AbstractApplicationProvider {
  urlPath = 'application_oper_api'

  public oper<T = any>(action: OperActions, params: ApplicationOperParams): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }

  public oper_post<T = any>(
    action: OperPostActions,
    { AppID, HashSum_AppID_, Comment }: ApplicationOperPostParams,
  ): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      AppID,
      HashSum_AppID_,
    })

    return this.http.post(`${this.url}?${query}`, {
      Comment,
    })
  }
}
